/**
 * Production's **Priority Signals**, copied from its `lib/utils.ts` at
 * `11ca09a`.
 *
 * Four thresholds over the four scores: two fire when a score is high (friction
 * and recovery are bad when large), two when a score is low (readiness and
 * clarity are good when large). A customer with no elevated signal gets no
 * section at all, which is why the empty list matters.
 */
export interface PrioritySignal {
  id: string;
  text: string;
}

export function computePrioritySignals(scores: {
  bottleneckScore: number;
  executionReadinessScore: number;
  recoveryDeficitScore: number;
  clarityScore: number;
}): PrioritySignal[] {
  const signals: PrioritySignal[] = [];

  if (scores.bottleneckScore >= 70) {
    signals.push({
      id: 'bottleneck',
      text: 'Your overall friction load is elevated. This pattern is actively competing with your output capacity.',
    });
  }
  if (scores.recoveryDeficitScore >= 70) {
    signals.push({
      id: 'recovery',
      text: 'Recovery is likely limiting your sustainable execution. High output with low recovery is not a strategy, it is a ceiling.',
    });
  }
  if (scores.executionReadinessScore <= 40) {
    signals.push({
      id: 'execution',
      text: 'Consistency may be the first system to stabilize. Execution gaps compound quickly when left unaddressed.',
    });
  }
  if (scores.clarityScore <= 40) {
    signals.push({
      id: 'clarity',
      text: 'Decision friction may be slowing your follow-through. Directional uncertainty tends to cost more energy than the decision itself.',
    });
  }

  return signals;
}
